import React, { useState } from 'react';
import { Link } from 'react-router-dom';
import {
  Alert, Button, Card, CardBody, CardHeader, Form, Input, Label, Spinner,
} from 'reactstrap';
import { get } from '../../helpers/api_helper';

export default function OrderImport() {
  const [orderId, setOrderId] = useState('');
  const [loading, setLoading] = useState(false);
  const [result, setResult] = useState(null);
  const [error, setError] = useState('');

  const importOrder = async (event) => {
    event.preventDefault();
    if (loading) return;
    setError('');
    setResult(null);
    const id = orderId.trim();
    if (!/^[1-9]\d*$/.test(id)) {
      setError('Enter a positive numeric ChannelAdvisor order ID.');
      return;
    }
    setLoading(true);
    try {
      const response = await get(`/api/ca/sale/${id}`);
      if (!response?.sale_id || !['created', 'exists'].includes(response.status)) {
        throw new Error('The import did not return a BASE sale. Check the order ID and try again.');
      }
      setResult(response);
    } catch (err) {
      const body = err.response?.data;
      setError((typeof body === 'string' ? body : body?.error) || err.message || 'Unable to import order.');
    } finally {
      setLoading(false);
    }
  };

  return (
    <Card>
      <CardHeader className="bg-transparent border-bottom">ChannelAdvisor Order Import</CardHeader>
      <CardBody>
        <p className="text-muted">Import an order directly into BASE/Party using its numeric ChannelAdvisor order ID.</p>
        <Form onSubmit={importOrder} noValidate>
          <Label for="channeladvisor-order-id">ChannelAdvisor Order ID</Label>
          <div className="d-flex gap-2 mb-3">
            <Input
              id="channeladvisor-order-id"
              value={orderId}
              onChange={(event) => setOrderId(event.target.value)}
              inputMode="numeric"
              placeholder="e.g. 12345678"
              disabled={loading}
            />
            <Button color="primary" type="submit" disabled={loading} className="text-nowrap">
              {loading && <Spinner size="sm" className="me-1" />}
              {loading ? 'Importing…' : 'Import Order'}
            </Button>
          </div>
        </Form>
        {error && <Alert color="danger" role="alert">{error}</Alert>}
        {result && (
          <>
            <Alert color="success" role="status">
              {result.status === 'exists' ? 'Order already exists in BASE. ' : 'Order imported into BASE. '}
              <Link to={`/sales/${result.sale_id}`}>
                View sale #
                {result.sale_id}
              </Link>
            </Alert>
            {result.unmatched_items?.length > 0 && (
              <Alert color="warning">
                <strong>Some order items could not be matched:</strong>
                <pre className="mb-0 mt-2 text-wrap">{JSON.stringify(result.unmatched_items, null, 2)}</pre>
              </Alert>
            )}
            {result.status === 'created' && result.exported === false && (
              <Alert color="warning">
                Order saved in BASE, but ChannelAdvisor could not be marked as exported.
                {result.export_error && <div>{result.export_error}</div>}
              </Alert>
            )}
          </>
        )}
      </CardBody>
    </Card>
  );
}
